import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import LearningAdminModulesGridList from '../components/LearningAdminModulesGridList';
import {
  loadModulesAdminByModuleSerieId,
  patchModuleAdmin,
  deleteModuleAdmin,
} from '../../../../../state/modules/learningsAdmin/actions';
import storage from '../../../../../lib/Storage';
import store from '../../../../../state/store';
import { findStorageType } from '../../../../../lib/Auth';

const defaultLimit = 20;
const defaultOrder = 'order.asc';
const defaultScope = 'list';

const mapStateToProps = (state, ownProps) => {
  const moduleSerieId = ownProps.moduleSerieId;
  const partnershipId = storage.get(findStorageType(), 'partnershipId');

  // merge results for all modules
  const results = [].concat.apply(
    [],
    Object.entries(
      state.learningsAdmin.getIn(
        [
          'modulesAdmin',
          defaultScope,
          partnershipId,
          moduleSerieId,
          'pages',
          defaultOrder,
          defaultLimit,
        ],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['learningModulesAdmin', x]),
              schema.learningModuleAdmin,
              state.entities.toJS()
            ),
          };
        })
      : [];

  return {
    list,
    moduleSerieId,
    partnershipId,
    defaultLimit,
    defaultOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      partnershipId,
      moduleSerieId,
      filter = {},
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      scope = defaultScope,
      cb = function () {}
    ) => {
      dispatch(
        loadModulesAdminByModuleSerieId(
          partnershipId,
          moduleSerieId,
          filter,
          page,
          limit,
          order,
          scope,
          (success, total, result) => {
            if (success && result) {
              const state = store.getState();

              const normalizedResult = result.map((x) => {
                return {
                  key: x,
                  ...denormalize(
                    state.entities.getIn(['learningModulesAdmin', x]),
                    schema.learningModuleAdmin,
                    state.entities.toJS()
                  ),
                };
              });

              const pageCount = Math.ceil(total / limit);
              for (let i = 2; i <= pageCount; i++) {
                dispatch(
                  loadModulesAdminByModuleSerieId(
                    partnershipId,
                    moduleSerieId,
                    filter,
                    i,
                    limit,
                    order,
                    scope
                  )
                );
              }

              cb(true, normalizedResult);
            } else {
              cb(false, null);
            }
          }
        )
      );
    },
    patch: (partnershipId, id, data, cb) => {
      dispatch(patchModuleAdmin(partnershipId, id, data, cb));
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteModuleAdmin(partnershipId, id, cb));
    },
  };
};

const LearningAdminModulesGridListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModulesGridList);

export default LearningAdminModulesGridListContainer;
